import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { Fattura } from '../../../models/fattura';
import { SezioneFatture } from '../../../models/sezioni/sezione-fatture';
import { FattureEditComponent } from './fatture-edit.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [fattura-mod-edit]',
  templateUrl: 'fattura-mod-edit.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class FatturaModEdit {
  @Output() onReturn: EventEmitter<SezioneFatture> = new EventEmitter<SezioneFatture>();
  @ViewChild('formFatturaEdit') formFattura: FattureEditComponent;

  inizializza(sezione: SezioneFatture, fattura: Fattura, idSezioneAltreParti: string, urlUpdate: string, urlReadSezioneAltreParti: string) {
    this.formFattura.inizializza(sezione, fattura, idSezioneAltreParti, urlUpdate, urlReadSezioneAltreParti);
    openModal('modalmodFattura');
  }

  createForm() {
    this.formFattura.createForm();
  }

  manageModal(sezioneFatture: SezioneFatture) {
      closeModal('modalmodFattura');
      this.onReturn.emit(sezioneFatture);
  }
}
